export function initAlpineJs() {


	/**
	 * Video
	 * Load iframe src on click
	 */
	Alpine.data("video", () => ({
		isPlay: false,
		toggler: {
			["@click.prevent"]() {
				this.$refs.iframe.src = this.$refs.iframe.dataset.videoSrc;
				setTimeout(() => (this.isPlay = !this.isPlay), 300);
			},
			["x-bind:class"]() {
				return {
					"is-play": this.isPlay,
				};
			},
		},
	}));

	/**
	 * Dropdown content behavior,
	 * Content is triggered on hovering the toggler
	 * A translateY and opacity is applied with opacity, to toggle the content
	 */
	Alpine.data("dropdown", () => ({
		isOpen: false,
		debounceMethod: null,
		toggler: {
			"x-ref": "toggler",
			["@mouseover"]() {
				clearTimeout(this.debounceMethod);
				this.isOpen = true;
			},
			["@mouseout"]() {
				this.debounceMethod = setTimeout(() => (this.isOpen = false), 250);
			},
			["x-bind:class"]() {
				return {
					"is-open": this.isOpen,
				};
			},
		},
		content: {
			"x-ref": "content",
			["x-bind:style"]() {

				var isFirstElm = this.$el.classList.contains('data-is-first');
				var isLastElm = this.$el.classList.contains('data-is-last');

				var transformIfOpen = 'translate(-50%, 0)';
				// if(isFirstElm || isLastElm){
				// 	transformIfOpen = 'translate(0, 0)';
				// }

				var transformIfNotOpen = 'translate(-50%, 5px)';
				// if(isFirstElm || isLastElm){
				// 	transformIfNotOpen = 'translate(0, 5px)';
				// }

				return {
					overflow	: "hidden",
					transition	: "all 250ms",
					transform	: this.isOpen ? transformIfOpen : transformIfNotOpen,
					visibility	: this.isOpen ? "visible" : "hidden",
					opacity		: this.isOpen ? 1 : 0,
				};

			},
			["@mouseover"]() {
				clearTimeout(this.debounceMethod);
			},
			["@mouseout"]() {
				this.debounceMethod = setTimeout(() => (this.isOpen = false), 500);
			},
		},
	}));

	/**
	 * Drawer content behavior,
	 * Content is triggered by clicking the toggler,
	 * With a slide up / down effect
	 */
	Alpine.data("drawer", () => ({
		isOpen: false,
		toggler: {
			["x-init"]() {
				if (
					window.location.hash &&
					window.location.hash === "#" + this.$el.id
				) {
					this.isOpen = true;
					this.$el.scrollIntoView({
						block: "center",
						inline: "nearest",
						behavior: "smooth",
					});
				}
			},
			["@click.prevent"]() {
				this.isOpen = !this.isOpen;
			},
			["x-bind:class"]() {
				return {
					"is-open": this.isOpen,
				};
			},
			"@open-drawer.window"($event) {
				if ($event.detail && $event.detail.id == this.$el.id) {
					this.isOpen = true;
					this.$el.scrollIntoView({
						block: "center",
						inline: "nearest",
						behavior: "smooth",
					});
				}
			},
		},
		content: {
			"x-ref": "content",
			["x-bind:style"]() {
				return {
					overflow: "hidden",
					transition: "all 400ms",
					height: this.isOpen ? `${this.$el.scrollHeight}px` : `0px`,
				};
			},
		},
	}));

	/**
	 * Instanciate the modal component
	 * Needs to be refactored
	 */
	Alpine.data("modal", () => ({
		isOpen: false,
		content: null,
		close: {
			"x-ref": "close",
			["@click"]() {
				this.isOpen = !this.isOpen;
			},
		},
	}));
	Alpine.bind("modal", () => ({
		":class"() {
			return {
				"is-open": this.isOpen,
			};
		},
		"@open-modal.window"($event) {
			if ($event.detail && $event.detail.id == this.$el.id) {
				this.isOpen = true;
			}
		},
		"@modal.window"($event) {
			this.isOpen = true;
			fetch($event.detail).then((resp) => {
				if (resp.ok) {
					this.content = resp.text();
				}
			});
		},
	}));

	/**
	 * Instanciate the tabs component
	 */
	Alpine.data("tabs", () => ({
		activeTab: 0,
		init() {
			const activateTabFromHash = () => {
				if (window.location.hash) {
					let activeContent = this.$el.querySelector(window.location.hash);
					this.activeTab = Array.prototype.indexOf.call(
						activeContent.parentElement.children,
						activeContent
					);
				}
			};
			activateTabFromHash();
			window.addEventListener("hashchange", activateTabFromHash);
		},
		tab: {
			["@click"](event) {
				this.activeTab = Array.prototype.indexOf.call(
					event.target.parentElement.children,
					event.target
				);
				if (event.target.getAttribute("aria-controls")) {
					const identifier = event.target.getAttribute("aria-controls");
					if (window.history.pushState) {
						window.history.pushState(null, null, "#" + identifier);
					} else {
						window.location.hash = identifier;
					}
				}
			},
			["x-bind:class"]() {
				return {
					"is-active":
						this.activeTab ===
						Array.prototype.indexOf.call(
							this.$el.parentElement.children,
							this.$el
						),
				};
			},
		},
		content: {
			["x-bind:class"]() {
				return {
					"is-active":
						this.activeTab ===
						Array.prototype.indexOf.call(
							this.$el.parentElement.children,
							this.$el
						),
				};
			},
		},
	}));
}
